module.exports = __webpack_public_path__ + "img/hr-tank-base-1.c4ecffde.png";